import _toConsumableArray from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _assertThisInitialized from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/Users/joeloliveira/Development/WWW/Projects/notificare-website/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Logger, setLogLevel as setLogLevel$1, LogLevel } from '@notificare/web-logger';
import { deleteCloudDevice, createCloudDevice, updateCloudDevice, upgradeToLongLivedCloudDevice, registerCloudTestDevice, createCloudEvent, request, fetchCloudNotification, fetchCloudDynamicLink, callCloudNotificationWebhook, uploadCloudNotificationReplyMedia, createCloudNotificationReply, fetchCloudApplication, fetchCloudDeviceTags, addCloudDeviceTags, removeCloudDeviceTags, clearCloudDeviceTags, fetchCloudDeviceDoNotDisturb, fetchCloudDeviceUserData } from '@notificare/web-cloud-api';
export { NotificareNetworkRequestError } from '@notificare/web-cloud-api';
var logger = new Logger('notificare');
var components = new Map();

function registerComponent(component) {
  if (components.has(component.name)) {
    logger.debug("The component ".concat(component.name, " was registered already."));
    return;
  }

  components.set(component.name, component);
}

function broadcastComponentEvent(event, data) {
  // eslint-disable-next-line no-restricted-syntax
  var _iterator = _createForOfIteratorHelper(components.values()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var component = _step.value;
      component.processBroadcast(event, data);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function executeComponentCommand(_x) {
  return _executeComponentCommand.apply(this, arguments);
}

function _executeComponentCommand() {
  _executeComponentCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref) {
    var component, command, data, instance;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            component = _ref.component, command = _ref.command, data = _ref.data;
            instance = components.get(component);

            if (instance) {
              _context13.next = 4;
              break;
            }

            throw new Error("Unable to find an instance for component '".concat(component, "'."));

          case 4:
            return _context13.abrupt("return", instance.executeCommand(command, data));

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _executeComponentCommand.apply(this, arguments);
}

var Component = /*#__PURE__*/function () {
  function Component(name) {
    _classCallCheck(this, Component);

    this.name = name;
  } // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars


  _createClass(Component, [{
    key: "migrate",
    value: function migrate() {} // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-empty-function

  }, {
    key: "clearStorage",
    value: function () {
      var _clearStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function clearStorage() {
        return _clearStorage.apply(this, arguments);
      }

      return clearStorage;
    }() // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-empty-function

  }, {
    key: "postLaunch",
    value: function () {
      var _postLaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function postLaunch() {
        return _postLaunch.apply(this, arguments);
      }

      return postLaunch;
    }() // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars

  }, {
    key: "processBroadcast",
    value: function processBroadcast(event, data) {} // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars

  }, {
    key: "executeCommand",
    value: function () {
      var _executeCommand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(command, data) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new Error("The '".concat(this.name, "' component does not support commands."));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function executeCommand(_x2, _x3) {
        return _executeCommand.apply(this, arguments);
      }

      return executeCommand;
    }()
  }]);

  return Component;
}();

var onReadyCallback;
var unlaunchedCallback;
var deviceRegisteredCallback;

function onReady(callback) {
  onReadyCallback = callback;
  return {
    remove: function remove() {
      onReadyCallback = undefined;
    }
  };
}

function onUnlaunched(callback) {
  unlaunchedCallback = callback;
  return {
    remove: function remove() {
      unlaunchedCallback = undefined;
    }
  };
}

function onDeviceRegistered(callback) {
  deviceRegisteredCallback = callback;
  return {
    remove: function remove() {
      deviceRegisteredCallback = undefined;
    }
  };
}

function notifyOnReady(application) {
  var callback = onReadyCallback;

  if (!callback) {
    logger.debug("The 'on_ready' handler is not configured.");
    return;
  }

  callback(application);
}

function notifyUnlaunched() {
  var callback = unlaunchedCallback;

  if (!callback) {
    logger.debug("The 'on_unlaunched' handler is not configured.");
    return;
  }

  callback();
}

function notifyDeviceRegistered(device) {
  var callback = deviceRegisteredCallback;

  if (!callback) {
    logger.debug("The 'device_registered' handler is not configured.");
    return;
  }

  callback(device);
}

var NotificareDeviceUnavailableError = /*#__PURE__*/function (_Error) {
  _inherits(NotificareDeviceUnavailableError, _Error);

  var _super = _createSuper(NotificareDeviceUnavailableError);

  function NotificareDeviceUnavailableError() {
    var _this;

    _classCallCheck(this, NotificareDeviceUnavailableError);

    _this = _super.call(this, 'Notificare device unavailable at the moment. It becomes available after the first ready event.');
    Object.setPrototypeOf(_assertThisInitialized(_this), NotificareDeviceUnavailableError.prototype);
    return _this;
  }

  return _createClass(NotificareDeviceUnavailableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var NotificareNotReadyError = /*#__PURE__*/function (_Error2) {
  _inherits(NotificareNotReadyError, _Error2);

  var _super2 = _createSuper(NotificareNotReadyError);

  function NotificareNotReadyError() {
    var _this2;

    _classCallCheck(this, NotificareNotReadyError);

    _this2 = _super2.call(this, 'Notificare is not ready.');
    Object.setPrototypeOf(_assertThisInitialized(_this2), NotificareNotReadyError.prototype);
    return _this2;
  }

  return _createClass(NotificareNotReadyError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var NotificareNotConfiguredError = /*#__PURE__*/function (_Error3) {
  _inherits(NotificareNotConfiguredError, _Error3);

  var _super3 = _createSuper(NotificareNotConfiguredError);

  function NotificareNotConfiguredError() {
    var _this3;

    _classCallCheck(this, NotificareNotConfiguredError);

    _this3 = _super3.call(this, "Notificare hasn't been configured.");
    Object.setPrototypeOf(_assertThisInitialized(_this3), NotificareNotConfiguredError.prototype);
    return _this3;
  }

  return _createClass(NotificareNotConfiguredError);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle


var _options;

var DEFAULT_CLOUD_API_HOST = 'cloud.notifica.re';
var DEFAULT_REST_API_HOST = 'push.notifica.re';

function getOptions() {
  return _options;
}

function setOptions(options) {
  _options = options;
}

function isDefaultHosts(hosts) {
  return hosts.cloudApi === DEFAULT_CLOUD_API_HOST && hosts.restApi === DEFAULT_REST_API_HOST;
}

function getCloudApiEnvironment() {
  var options = getOptions();
  if (!options) throw new NotificareNotConfiguredError();
  return {
    cloudHost: options.hosts.cloudApi,
    applicationKey: options.applicationKey,
    applicationSecret: options.applicationSecret
  };
}

var LaunchState;

(function (LaunchState) {
  LaunchState[LaunchState["NONE"] = 0] = "NONE";
  LaunchState[LaunchState["CONFIGURED"] = 1] = "CONFIGURED";
  LaunchState[LaunchState["LAUNCHING"] = 2] = "LAUNCHING";
  LaunchState[LaunchState["LAUNCHED"] = 3] = "LAUNCHED";
})(LaunchState || (LaunchState = {}));

var launchState = LaunchState.NONE;

function isConfigured$1() {
  return getLaunchState() >= LaunchState.CONFIGURED;
}

function isReady$1() {
  return launchState >= LaunchState.LAUNCHED;
}

function getLaunchState() {
  return launchState;
}

function setLaunchState(state) {
  launchState = state;
}

function getStoredApplication() {
  var applicationStr = localStorage.getItem('re.notifica.application');
  if (!applicationStr) return undefined;

  try {
    return JSON.parse(applicationStr);
  } catch (e) {
    logger.warning('Failed to decode the stored application.', e); // Remove the corrupted application from local storage.

    setStoredApplication(undefined);
    return undefined;
  }
}

function setStoredApplication(application) {
  if (!application) {
    localStorage.removeItem('re.notifica.application');
    return;
  }

  localStorage.setItem('re.notifica.application', JSON.stringify(application));
}

function getStoredDevice() {
  var deviceStr = localStorage.getItem('re.notifica.device');
  if (!deviceStr) return undefined;

  try {
    return JSON.parse(deviceStr);
  } catch (e) {
    logger.warning('Failed to decode the stored device.', e); // Remove the corrupted device from local storage.

    setStoredDevice(undefined);
    return undefined;
  }
}

function setStoredDevice(device) {
  if (!device) {
    localStorage.removeItem('re.notifica.device');
    return;
  }

  localStorage.setItem('re.notifica.device', JSON.stringify(device));
}

function isLongLivedDevice(device) {
  return device.transport === undefined || device.transport === null;
}

function asPublicDevice(device) {
  return {
    id: device.id,
    userId: device.userId,
    userName: device.userName,
    timeZoneOffset: device.timeZoneOffset,
    dnd: device.dnd,
    userData: device.userData
  };
}

function clearStorage() {
  setStoredApplication(undefined);
  setStoredDevice(undefined);
  localStorage.removeItem('re.notifica.preferred_language');
  localStorage.removeItem('re.notifica.preferred_region');
  localStorage.removeItem('re.notifica.migrated');
  localStorage.removeItem('re.notifica.session');
  localStorage.removeItem('re.notifica.unload_timestamp');
}

function randomUUID() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (// eslint-disable-next-line no-bitwise
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  });
}

function getTimeZoneOffset() {
  var now = new Date();
  return now.getTimezoneOffset() / 60 * -1;
}

function getApplicationVersion() {
  var _a, _b;

  return (_b = (_a = getOptions()) === null || _a === void 0 ? void 0 : _a.applicationVersion) !== null && _b !== void 0 ? _b : '1.0.0';
}

function getBrowserLanguage() {
  var language = 'en'; // Not using userLanguage anymore since it's deprecated, and it reflects the language
  // of the OS instead of the browser.

  var browserLanguage = window.navigator.language;
  if (!browserLanguage) return language;
  var parts = browserLanguage.split('-');
  if (parts.length > 0) return parts[0].toLowerCase();
  return language;
}

function getBrowserRegion() {
  var language = 'US'; // Not using userLanguage anymore since it's deprecated, and it reflects the language
  // of the OS instead of the browser.

  var browserLanguage = window.navigator.language;
  if (!browserLanguage) return language;
  var parts = browserLanguage.split('-');
  if (parts.length > 1) return parts[1].toUpperCase();
  return language;
}

function hasWebPushSupport() {
  return _hasWebPushSupport.apply(this, arguments);
}

function _hasWebPushSupport() {
  _hasWebPushSupport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var pushComponent, result;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            pushComponent = components.get('push');

            if (pushComponent) {
              _context14.next = 4;
              break;
            }

            logger.debug('Cannot determine web push support. Push component not found.');
            return _context14.abrupt("return", false);

          case 4:
            _context14.next = 6;
            return pushComponent.executeCommand('hasWebPushSupport');

          case 6:
            result = _context14.sent;
            return _context14.abrupt("return", result === true);

          case 8:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _hasWebPushSupport.apply(this, arguments);
}

function loadStylesheet(url) {
  var _a;

  var head = (_a = document.head) !== null && _a !== void 0 ? _a : document.getElementsByTagName('head')[0];

  if (!head) {
    logger.warning('The document head is not defined.');
    return;
  }

  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}

var SDK_VERSION$1 = '4.0.0';

function createDevice() {
  return _createDevice.apply(this, arguments);
}

function _createDevice() {
  _createDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var payload, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            payload = {
              language: getDeviceLanguage(),
              region: getDeviceRegion(),
              platform: 'Web',
              sdkVersion: SDK_VERSION$1,
              appVersion: getApplicationVersion(),
              userAgent: navigator.userAgent,
              timeZoneOffset: getTimeZoneOffset()
            };
            _context15.next = 3;
            return createCloudDevice({
              environment: getCloudApiEnvironment(),
              payload: payload
            });

          case 3:
            response = _context15.sent;
            setStoredDevice({
              id: response.device.deviceID,
              userId: undefined,
              userName: undefined,
              timeZoneOffset: payload.timeZoneOffset,
              sdkVersion: payload.sdkVersion,
              appVersion: payload.appVersion,
              userAgent: payload.userAgent,
              language: payload.language,
              region: payload.region,
              dnd: undefined,
              userData: {}
            });

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _createDevice.apply(this, arguments);
}

function updateDevice() {
  return _updateDevice.apply(this, arguments);
}

function _updateDevice() {
  _updateDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var device, payload;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            device = getStoredDevice();

            if (device) {
              _context16.next = 3;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 3:
            payload = {
              language: getDeviceLanguage(),
              region: getDeviceRegion(),
              platform: 'Web',
              sdkVersion: SDK_VERSION$1,
              appVersion: getApplicationVersion(),
              userAgent: navigator.userAgent,
              timeZoneOffset: getTimeZoneOffset()
            };
            _context16.next = 6;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: payload
            });

          case 6:
            setStoredDevice(Object.assign(Object.assign({}, device), {
              language: payload.language,
              region: payload.region,
              sdkVersion: payload.sdkVersion,
              appVersion: payload.appVersion,
              userAgent: payload.userAgent,
              timeZoneOffset: payload.timeZoneOffset
            }));

          case 7:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _updateDevice.apply(this, arguments);
}

function upgradeToLongLivedDeviceWhenNeeded() {
  return _upgradeToLongLivedDeviceWhenNeeded.apply(this, arguments);
}

function _upgradeToLongLivedDeviceWhenNeeded() {
  _upgradeToLongLivedDeviceWhenNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var _a, _b, _c, currentDevice, payload, response, createDeviceResponse;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            currentDevice = getStoredDevice();

            if (currentDevice) {
              _context17.next = 3;
              break;
            }

            return _context17.abrupt("return");

          case 3:
            if (!(isLongLivedDevice(currentDevice) || !currentDevice.transport)) {
              _context17.next = 5;
              break;
            }

            return _context17.abrupt("return");

          case 5:
            logger.info('Upgrading current device from legacy format.');
            payload = {
              deviceID: currentDevice.id,
              transport: currentDevice.transport,
              subscriptionId: currentDevice.transport !== 'Notificare' ? currentDevice.id : undefined,
              keys: (_a = currentDevice.keys) !== null && _a !== void 0 ? _a : undefined,
              language: currentDevice.language,
              region: currentDevice.region,
              platform: 'Web',
              sdkVersion: currentDevice.sdkVersion,
              appVersion: currentDevice.appVersion,
              userAgent: currentDevice.userAgent,
              timeZoneOffset: currentDevice.timeZoneOffset
            };
            _context17.next = 9;
            return upgradeToLongLivedCloudDevice({
              environment: getCloudApiEnvironment(),
              payload: payload
            });

          case 9:
            response = _context17.sent;

            if (!(response.status === 201)) {
              _context17.next = 16;
              break;
            }

            _context17.next = 13;
            return response.json();

          case 13:
            _context17.t0 = _context17.sent;
            _context17.next = 17;
            break;

          case 16:
            _context17.t0 = undefined;

          case 17:
            createDeviceResponse = _context17.t0;

            if (createDeviceResponse) {
              logger.debug('New device identifier created.');
            }

            setStoredDevice({
              id: (_c = (_b = createDeviceResponse === null || createDeviceResponse === void 0 ? void 0 : createDeviceResponse.device) === null || _b === void 0 ? void 0 : _b.deviceID) !== null && _c !== void 0 ? _c : currentDevice.id,
              userId: currentDevice.userId,
              userName: currentDevice.userName,
              timeZoneOffset: currentDevice.timeZoneOffset,
              sdkVersion: currentDevice.sdkVersion,
              appVersion: currentDevice.appVersion,
              userAgent: currentDevice.userAgent,
              language: currentDevice.language,
              region: currentDevice.region,
              dnd: currentDevice.dnd,
              userData: currentDevice.userData
            });

          case 20:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _upgradeToLongLivedDeviceWhenNeeded.apply(this, arguments);
}

function registerTestDevice(_x4) {
  return _registerTestDevice.apply(this, arguments);
}

function _registerTestDevice() {
  _registerTestDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(nonce) {
    var device;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            device = getStoredDevice();

            if (device) {
              _context18.next = 3;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 3:
            _context18.next = 5;
            return registerCloudTestDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              nonce: nonce
            });

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _registerTestDevice.apply(this, arguments);
}

function deleteDevice() {
  return _deleteDevice.apply(this, arguments);
}

function _deleteDevice() {
  _deleteDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    var device;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            device = getStoredDevice();

            if (device) {
              _context19.next = 3;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 3:
            _context19.next = 5;
            return deleteCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id
            });

          case 5:
            setStoredDevice(undefined);

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _deleteDevice.apply(this, arguments);
}

function checkPrerequisites() {
  if (!isReady$1()) {
    logger.warning('Notificare is not ready yet.');
    throw new NotificareNotReadyError();
  }
}

function getDeviceLanguage() {
  var preferredLanguage = localStorage.getItem('re.notifica.preferred_language');
  if (!preferredLanguage) return getBrowserLanguage();
  return preferredLanguage;
}

function getDeviceRegion() {
  var preferredRegion = localStorage.getItem('re.notifica.preferred_region');
  if (!preferredRegion) return getBrowserRegion();
  return preferredRegion;
}

function getSession() {
  var sessionStr = localStorage.getItem('re.notifica.session');
  if (!sessionStr) return undefined;

  try {
    return JSON.parse(sessionStr);
  } catch (e) {
    logger.warning('Failed to decode the stored session.', e); // Remove the corrupted session from local storage.

    storeSession(undefined);
    return undefined;
  }
}

function storeSession(session) {
  if (!session) {
    localStorage.removeItem('re.notifica.session');
    localStorage.removeItem('re.notifica.unload_timestamp');
    return;
  }

  localStorage.setItem('re.notifica.session', JSON.stringify(session));
}

function logApplicationInstall() {
  return _logApplicationInstall.apply(this, arguments);
}

function _logApplicationInstall() {
  _logApplicationInstall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return logInternal({
              type: 're.notifica.event.application.Install'
            });

          case 2:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _logApplicationInstall.apply(this, arguments);
}

function logApplicationRegistration() {
  return _logApplicationRegistration.apply(this, arguments);
}

function _logApplicationRegistration() {
  _logApplicationRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return logInternal({
              type: 're.notifica.event.application.Registration'
            });

          case 2:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _logApplicationRegistration.apply(this, arguments);
}

function logApplicationUpgrade() {
  return _logApplicationUpgrade.apply(this, arguments);
}

function _logApplicationUpgrade() {
  _logApplicationUpgrade = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return logInternal({
              type: 're.notifica.event.application.Upgrade'
            });

          case 2:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _logApplicationUpgrade.apply(this, arguments);
}

function logApplicationOpen(_x5) {
  return _logApplicationOpen.apply(this, arguments);
}

function _logApplicationOpen() {
  _logApplicationOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(sessionId) {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return logInternal({
              type: 're.notifica.event.application.Open',
              sessionId: sessionId
            });

          case 2:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _logApplicationOpen.apply(this, arguments);
}

function logApplicationClose(_x6, _x7, _x8) {
  return _logApplicationClose.apply(this, arguments);
}

function _logApplicationClose() {
  _logApplicationClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(sessionId, sessionLength, sessionCloseTimestamp) {
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return logInternal({
              type: 're.notifica.event.application.Close',
              timestamp: sessionCloseTimestamp,
              sessionId: sessionId,
              data: {
                length: sessionLength.toString()
              }
            });

          case 2:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _logApplicationClose.apply(this, arguments);
}

function logNotificationOpen(_x9) {
  return _logNotificationOpen.apply(this, arguments);
}

function _logNotificationOpen() {
  _logNotificationOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(notificationId) {
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return logInternal({
              type: 're.notifica.event.notification.Open',
              notificationId: notificationId
            });

          case 2:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _logNotificationOpen.apply(this, arguments);
}

function logCustom(_x10, _x11) {
  return _logCustom.apply(this, arguments);
}

function _logCustom() {
  _logCustom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(event, data) {
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return logInternal({
              type: "re.notifica.event.custom.".concat(event),
              data: data
            });

          case 2:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _logCustom.apply(this, arguments);
}

function logInternal(_x12) {
  return _logInternal.apply(this, arguments);
}

function _logInternal() {
  _logInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(options) {
    var _a, _b, _c, currentDevice;

    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            if (isConfigured$1()) {
              _context27.next = 3;
              break;
            }

            logger.debug('Notificare is not configured. Skipping event log...');
            return _context27.abrupt("return");

          case 3:
            currentDevice = getStoredDevice();
            _context27.next = 6;
            return createCloudEvent({
              environment: getCloudApiEnvironment(),
              payload: {
                type: options.type,
                timestamp: (_a = options.timestamp) !== null && _a !== void 0 ? _a : Date.now(),
                deviceID: currentDevice === null || currentDevice === void 0 ? void 0 : currentDevice.id,
                userID: currentDevice === null || currentDevice === void 0 ? void 0 : currentDevice.userId,
                sessionID: (_b = options.sessionId) !== null && _b !== void 0 ? _b : (_c = getSession()) === null || _c === void 0 ? void 0 : _c.id,
                notification: options.notificationId,
                data: options.data
              }
            });

          case 6:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _logInternal.apply(this, arguments);
}

var TEN_MINUTES_MILLISECONDS = 600000;
var sessionCloseTimeout;

function launch$1() {
  return _launch$.apply(this, arguments);
}

function _launch$() {
  _launch$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
    var currentSession, unloadTimestampStr, unloadTimestamp, tenSecondsAgo;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            currentSession = getSession();

            if (currentSession) {
              _context28.next = 5;
              break;
            }

            _context28.next = 4;
            return startSession();

          case 4:
            return _context28.abrupt("return");

          case 5:
            unloadTimestampStr = localStorage.getItem('re.notifica.unload_timestamp');

            if (unloadTimestampStr) {
              _context28.next = 9;
              break;
            }

            logger.debug('Resuming previous session (no unload timestamp).');
            return _context28.abrupt("return");

          case 9:
            unloadTimestamp = parseInt(unloadTimestampStr, 10);
            tenSecondsAgo = Date.now() - 10000;

            if (!(unloadTimestamp >= tenSecondsAgo)) {
              _context28.next = 15;
              break;
            }

            logger.debug('Resuming previous session.');
            localStorage.removeItem('re.notifica.unload_timestamp');
            return _context28.abrupt("return");

          case 15:
            _context28.next = 17;
            return stopSession(currentSession, unloadTimestamp);

          case 17:
            _context28.next = 19;
            return startSession();

          case 19:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _launch$.apply(this, arguments);
}

function unlaunch$1() {
  return _unlaunch$.apply(this, arguments);
}

function _unlaunch$() {
  _unlaunch$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
    var currentSession, currentDevice;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            currentSession = getSession();
            currentDevice = getStoredDevice();

            if (!(!currentSession || !currentDevice)) {
              _context29.next = 4;
              break;
            }

            return _context29.abrupt("return");

          case 4:
            _context29.next = 6;
            return stopSession(currentSession, Date.now());

          case 6:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _unlaunch$.apply(this, arguments);
}

function handleDocumentVisibilityChanged() {
  return _handleDocumentVisibilityChanged.apply(this, arguments);
}

function _handleDocumentVisibilityChanged() {
  _handleDocumentVisibilityChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
    var options, device, session, _document, visibilityState;

    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            if (isReady$1()) {
              _context31.next = 2;
              break;
            }

            return _context31.abrupt("return");

          case 2:
            options = getOptions();
            device = getStoredDevice();

            if (!((options === null || options === void 0 ? void 0 : options.ignoreTemporaryDevices) && !device)) {
              _context31.next = 6;
              break;
            }

            return _context31.abrupt("return");

          case 6:
            session = getSession();
            _document = document, visibilityState = _document.visibilityState;

            if (sessionCloseTimeout) {
              window.clearTimeout(sessionCloseTimeout);
              sessionCloseTimeout = undefined;
            }

            if (!(visibilityState === 'visible' && !session)) {
              _context31.next = 13;
              break;
            }

            _context31.next = 12;
            return startSession();

          case 12:
            return _context31.abrupt("return");

          case 13:
            if (visibilityState === 'hidden' && session) {
              sessionCloseTimeout = window.setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
                return _regeneratorRuntime.wrap(function _callee30$(_context30) {
                  while (1) {
                    switch (_context30.prev = _context30.next) {
                      case 0:
                        _context30.prev = 0;
                        _context30.next = 3;
                        return stopSession(session, Date.now());

                      case 3:
                        _context30.next = 8;
                        break;

                      case 5:
                        _context30.prev = 5;
                        _context30.t0 = _context30["catch"](0);
                        logger.error('Failed to stop the session after the idle timeout.', _context30.t0);

                      case 8:
                      case "end":
                        return _context30.stop();
                    }
                  }
                }, _callee30, null, [[0, 5]]);
              })), TEN_MINUTES_MILLISECONDS);
            }

          case 14:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _handleDocumentVisibilityChanged.apply(this, arguments);
}

function handleDocumentBeforeUnload() {
  if (!getSession()) return;
  localStorage.setItem('re.notifica.unload_timestamp', Date.now().toString(10));
}

function startSession() {
  return _startSession.apply(this, arguments);
}

function _startSession() {
  _startSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
    var session;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            session = {
              id: randomUUID(),
              start: Date.now()
            };
            logger.debug("Session '".concat(session.id, "' started at ").concat(session.start, " (epoch)."));
            storeSession(session);
            _context32.next = 5;
            return logApplicationOpen(session.id);

          case 5:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _startSession.apply(this, arguments);
}

function stopSession(_x13, _x14) {
  return _stopSession.apply(this, arguments);
}
/* eslint-disable class-methods-use-this */


function _stopSession() {
  _stopSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(session, sessionCloseTimestamp) {
    var sessionLength;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            logger.debug("Session '".concat(session.id, "' stopped at ").concat(sessionCloseTimestamp, " (epoch)."));
            storeSession(undefined);
            sessionLength = (sessionCloseTimestamp - session.start) / 1000;
            _context33.next = 5;
            return logApplicationClose(session.id, sessionLength, sessionCloseTimestamp);

          case 5:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _stopSession.apply(this, arguments);
}

var DeviceComponent = /*#__PURE__*/function (_Component) {
  _inherits(DeviceComponent, _Component);

  var _super4 = _createSuper(DeviceComponent);

  function DeviceComponent() {
    var _this4;

    _classCallCheck(this, DeviceComponent);

    _this4 = _super4.call(this, 'device');
    _this4.hasPendingDeviceRegistrationEvent = false;
    return _this4;
  }

  _createClass(DeviceComponent, [{
    key: "configure",
    value: function configure() {//
    }
  }, {
    key: "launch",
    value: function () {
      var _launch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var device, options, isApplicationUpgrade;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return upgradeToLongLivedDeviceWhenNeeded();

              case 2:
                device = getStoredDevice();
                options = getOptions();

                if (!(!device && !(options === null || options === void 0 ? void 0 : options.ignoreTemporaryDevices))) {
                  _context4.next = 17;
                  break;
                }

                logger.debug('New install detected.');
                _context4.prev = 6;
                _context4.next = 9;
                return this.handleCreateDeviceWithSession();

              case 9:
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](6);
                logger.warning('Failed to register temporary device.', _context4.t0);
                throw _context4.t0;

              case 15:
                _context4.next = 30;
                break;

              case 17:
                if (!device) {
                  _context4.next = 29;
                  break;
                }

                isApplicationUpgrade = device.appVersion !== getApplicationVersion();
                _context4.next = 21;
                return updateDevice();

              case 21:
                _context4.next = 23;
                return launch$1();

              case 23:
                if (!isApplicationUpgrade) {
                  _context4.next = 27;
                  break;
                }

                // It's not the same version, let's log it as an upgrade.
                logger.debug('New version detected.');
                _context4.next = 27;
                return logApplicationUpgrade();

              case 27:
                _context4.next = 30;
                break;

              case 29:
                logger.debug('Ignoring temporary devices.');

              case 30:
                this.handleTestDeviceRegistration();

              case 31:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 11]]);
      }));

      function launch() {
        return _launch.apply(this, arguments);
      }

      return launch;
    }()
  }, {
    key: "unlaunch",
    value: function () {
      var _unlaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function unlaunch() {
        return _unlaunch.apply(this, arguments);
      }

      return unlaunch;
    }()
  }, {
    key: "postLaunch",
    value: function () {
      var _postLaunch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var device;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                device = getStoredDevice();

                if (device && this.hasPendingDeviceRegistrationEvent) {
                  notifyDeviceRegistered(asPublicDevice(device));
                  this.hasPendingDeviceRegistrationEvent = false;
                }

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function postLaunch() {
        return _postLaunch2.apply(this, arguments);
      }

      return postLaunch;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-shadow

  }, {
    key: "executeCommand",
    value: function () {
      var _executeCommand2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(command, data) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(command === 'createDevice')) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 3;
                return this.handleCreateDeviceWithSession();

              case 3:
                return _context7.abrupt("return");

              case 4:
                if (!(command === 'deleteDevice')) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 7;
                return this.handleDeleteDeviceWithSession();

              case 7:
                return _context7.abrupt("return");

              case 8:
                throw new Error("Unsupported command '".concat(command, "' in '").concat(this.name, "' component."));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function executeCommand(_x15, _x16) {
        return _executeCommand2.apply(this, arguments);
      }

      return executeCommand;
    }()
  }, {
    key: "handleTestDeviceRegistration",
    value: function handleTestDeviceRegistration() {
      var searchParams = new URLSearchParams(window.location.search);
      var nonce = searchParams.get('notificareTestNonce');
      if (!nonce) return;
      registerTestDevice(nonce).then(function () {
        return logger.debug('Test device registered.');
      }).catch(function (error) {
        return logger.error("Failed to register the test device: ".concat(error));
      });
    }
  }, {
    key: "handleCreateDeviceWithSession",
    value: function () {
      var _handleCreateDeviceWithSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var device;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return createDevice();

              case 2:
                if (isReady$1()) {
                  device = getStoredDevice();
                  if (device) notifyDeviceRegistered(asPublicDevice(device));
                } else {
                  this.hasPendingDeviceRegistrationEvent = true;
                } // Having a stored device, we can safely launch the session module.


                _context8.next = 5;
                return launch$1();

              case 5:
                _context8.next = 7;
                return logApplicationInstall();

              case 7:
                _context8.next = 9;
                return logApplicationRegistration();

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleCreateDeviceWithSession() {
        return _handleCreateDeviceWithSession.apply(this, arguments);
      }

      return handleCreateDeviceWithSession;
    }()
  }, {
    key: "handleDeleteDeviceWithSession",
    value: function () {
      var _handleDeleteDeviceWithSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return unlaunch$1();

              case 2:
                _context9.next = 4;
                return deleteDevice();

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function handleDeleteDeviceWithSession() {
        return _handleDeleteDeviceWithSession.apply(this, arguments);
      }

      return handleDeleteDeviceWithSession;
    }()
  }]);

  return DeviceComponent;
}(Component);
/* eslint-disable class-methods-use-this */


var SessionComponent = /*#__PURE__*/function (_Component2) {
  _inherits(SessionComponent, _Component2);

  var _super5 = _createSuper(SessionComponent);

  function SessionComponent() {
    _classCallCheck(this, SessionComponent);

    return _super5.call(this, 'session');
  }

  _createClass(SessionComponent, [{
    key: "configure",
    value: function configure() {
      window.addEventListener('visibilitychange', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return handleDocumentVisibilityChanged();

              case 3:
                _context10.next = 8;
                break;

              case 5:
                _context10.prev = 5;
                _context10.t0 = _context10["catch"](0);
                logger.error('Failed to handle a document visibility changed event.', _context10.t0);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 5]]);
      })), false);
      window.addEventListener('beforeunload', handleDocumentBeforeUnload);
    }
    /**
     * This component does not partake in the launch flow because the
     * session module needs to be launched **after** a device is registered
     * but before any other events are logged.
     */

  }, {
    key: "launch",
    value: function () {
      var _launch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function launch() {
        return _launch2.apply(this, arguments);
      }

      return launch;
    }()
  }, {
    key: "unlaunch",
    value: function () {
      var _unlaunch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return unlaunch$1();

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function unlaunch() {
        return _unlaunch2.apply(this, arguments);
      }

      return unlaunch;
    }()
  }]);

  return SessionComponent;
}(Component);

function registerComponents() {
  registerComponent(new SessionComponent());
  registerComponent(new DeviceComponent());
}

function convertCloudNotificationToPublic(notification) {
  var _a, _b, _c, _d, _e, _f, _g;

  return {
    // eslint-disable-next-line no-underscore-dangle
    id: notification._id,
    partial: (_a = notification.partial) !== null && _a !== void 0 ? _a : false,
    type: notification.type,
    time: notification.time,
    title: notification.title,
    subtitle: notification.subtitle,
    message: notification.message,
    content: (_c = (_b = notification.content) === null || _b === void 0 ? void 0 : _b.map(convertNotificationContentToPublic)) !== null && _c !== void 0 ? _c : [],
    actions: ((_d = notification.actions) !== null && _d !== void 0 ? _d : []).reduce(function (acc, currentValue) {
      var action = convertNotificationActionToPublic(currentValue);
      if (action) acc.push(action);
      return acc;
    }, []),
    attachments: (_f = (_e = notification.attachments) === null || _e === void 0 ? void 0 : _e.map(convertNotificationAttachmentToPublic)) !== null && _f !== void 0 ? _f : [],
    extra: (_g = notification.extra) !== null && _g !== void 0 ? _g : {}
  };
}

function convertNotificationContentToPublic(content) {
  return {
    type: content.type,
    data: content.data
  };
}

function convertNotificationActionToPublic(action) {
  var _a, _b;

  if (!action.label) return undefined;
  return {
    // eslint-disable-next-line no-underscore-dangle
    id: action._id,
    type: action.type,
    label: action.label,
    target: action.target,
    camera: (_a = action.camera) !== null && _a !== void 0 ? _a : false,
    keyboard: (_b = action.keyboard) !== null && _b !== void 0 ? _b : false
  };
}

function convertNotificationAttachmentToPublic(attachment) {
  return {
    mimeType: attachment.mimeType,
    uri: attachment.uri
  };
}

var NotificareApplicationUnavailableError = /*#__PURE__*/function (_Error4) {
  _inherits(NotificareApplicationUnavailableError, _Error4);

  var _super6 = _createSuper(NotificareApplicationUnavailableError);

  function NotificareApplicationUnavailableError() {
    var _this5;

    _classCallCheck(this, NotificareApplicationUnavailableError);

    _this5 = _super6.call(this, 'Notificare application unavailable at the moment. It becomes available after the first ready event.');
    Object.setPrototypeOf(_assertThisInitialized(_this5), NotificareApplicationUnavailableError.prototype);
    return _this5;
  }

  return _createClass(NotificareApplicationUnavailableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var NotificareServiceUnavailableError = /*#__PURE__*/function (_Error5) {
  _inherits(NotificareServiceUnavailableError, _Error5);

  var _super7 = _createSuper(NotificareServiceUnavailableError);

  function NotificareServiceUnavailableError(service) {
    var _this6;

    _classCallCheck(this, NotificareServiceUnavailableError);

    _this6 = _super7.call(this, "Notificare '".concat(service, "' service is not available. Check the dashboard and documentation to enable it."));
    _this6.service = service;
    Object.setPrototypeOf(_assertThisInitialized(_this6), NotificareServiceUnavailableError.prototype);
    return _this6;
  }

  return _createClass(NotificareServiceUnavailableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function convertCloudApplicationToPublic(application) {
  var _a, _b;

  return {
    // eslint-disable-next-line no-underscore-dangle
    id: application._id,
    name: application.name,
    category: application.category,
    branding: (_a = application.branding) !== null && _a !== void 0 ? _a : true,
    services: (_b = application.services) !== null && _b !== void 0 ? _b : {},
    inboxConfig: convertInboxConfigToPublic(application.inboxConfig),
    regionConfig: convertRegionConfigToPublic(application.regionConfig),
    websitePushConfig: convertWebsitePushConfigToPublic(application.websitePushConfig),
    userDataFields: convertUserDataFieldsToPublic(application.userDataFields),
    actionCategories: convertActionCategoriesToPublic(application.actionCategories)
  };
}

function convertInboxConfigToPublic(inboxConfig) {
  var _a, _b, _c;

  if (!inboxConfig) return undefined;
  return {
    useInbox: (_a = inboxConfig.useInbox) !== null && _a !== void 0 ? _a : false,
    useUserInbox: (_b = inboxConfig.useUserInbox) !== null && _b !== void 0 ? _b : false,
    autoBadge: (_c = inboxConfig.autoBadge) !== null && _c !== void 0 ? _c : false
  };
}

function convertRegionConfigToPublic(regionConfig) {
  if (!(regionConfig === null || regionConfig === void 0 ? void 0 : regionConfig.proximityUUID)) return undefined;
  return {
    proximityUUID: regionConfig.proximityUUID
  };
}

function convertWebsitePushConfigToPublic(websitePushConfig) {
  if (!(websitePushConfig === null || websitePushConfig === void 0 ? void 0 : websitePushConfig.icon) || !(websitePushConfig === null || websitePushConfig === void 0 ? void 0 : websitePushConfig.allowedDomains)) {
    return undefined;
  }

  return {
    icon: websitePushConfig.icon,
    allowedDomains: websitePushConfig.allowedDomains,
    urlFormatString: websitePushConfig.urlFormatString,
    info: convertWebsitePushConfigInfoToPublic(websitePushConfig.info),
    vapid: convertWebsitePushConfigVapidToPublic(websitePushConfig.vapid),
    launchConfig: convertWebsitePushConfigLaunchConfigToPublic(websitePushConfig.launchConfig)
  };
}

function convertWebsitePushConfigInfoToPublic(info) {
  var _a, _b, _c, _d, _e;

  if (!((_a = info === null || info === void 0 ? void 0 : info.subject) === null || _a === void 0 ? void 0 : _a.UID) || !((_b = info === null || info === void 0 ? void 0 : info.subject) === null || _b === void 0 ? void 0 : _b.CN) || !((_c = info === null || info === void 0 ? void 0 : info.subject) === null || _c === void 0 ? void 0 : _c.OU) || !((_d = info === null || info === void 0 ? void 0 : info.subject) === null || _d === void 0 ? void 0 : _d.O) || !((_e = info === null || info === void 0 ? void 0 : info.subject) === null || _e === void 0 ? void 0 : _e.C)) {
    return undefined;
  }

  return {
    subject: {
      UID: info.subject.UID,
      CN: info.subject.CN,
      OU: info.subject.OU,
      O: info.subject.O,
      C: info.subject.C
    }
  };
}

function convertWebsitePushConfigVapidToPublic(vapid) {
  if (!(vapid === null || vapid === void 0 ? void 0 : vapid.publicKey)) return undefined;
  return {
    publicKey: vapid.publicKey
  };
}

function convertWebsitePushConfigLaunchConfigToPublic(launchConfig) {
  if (!launchConfig) return undefined;
  var autoOnboardingOptions = convertLaunchConfigAutoOnboardingToPublic(launchConfig.autoOnboardingOptions);
  var floatingButtonOptions = convertLaunchConfigFloatingButtonToPublic(launchConfig.floatingButtonOptions);
  if (!autoOnboardingOptions && !floatingButtonOptions) return undefined;
  return {
    autoOnboardingOptions: autoOnboardingOptions,
    floatingButtonOptions: floatingButtonOptions
  };
}

function convertLaunchConfigAutoOnboardingToPublic(autoOnboarding) {
  if (!autoOnboarding || !autoOnboarding.message || !autoOnboarding.acceptButton || !autoOnboarding.cancelButton) {
    return undefined;
  }

  return {
    message: autoOnboarding.message,
    acceptButton: autoOnboarding.acceptButton,
    cancelButton: autoOnboarding.cancelButton,
    retryAfterHours: autoOnboarding.retryAfterHours,
    showAfterSeconds: autoOnboarding.showAfterSeconds
  };
}

function convertLaunchConfigFloatingButtonToPublic(floatingButton) {
  var _a, _b, _c, _d, _e;

  if (!floatingButton || !((_a = floatingButton.alignment) === null || _a === void 0 ? void 0 : _a.horizontal) || !((_b = floatingButton.alignment) === null || _b === void 0 ? void 0 : _b.vertical) || !((_c = floatingButton.permissionTexts) === null || _c === void 0 ? void 0 : _c.default) || !((_d = floatingButton.permissionTexts) === null || _d === void 0 ? void 0 : _d.granted) || !((_e = floatingButton.permissionTexts) === null || _e === void 0 ? void 0 : _e.denied)) {
    return undefined;
  }

  return {
    alignment: {
      horizontal: floatingButton.alignment.horizontal,
      vertical: floatingButton.alignment.vertical
    },
    permissionTexts: {
      default: floatingButton.permissionTexts.default,
      granted: floatingButton.permissionTexts.granted,
      denied: floatingButton.permissionTexts.denied
    }
  };
}

function convertUserDataFieldsToPublic(userDataFields) {
  if (!userDataFields) return [];
  var result = [];
  userDataFields.forEach(function (userDataField) {
    if (!userDataField || !userDataField.type || !userDataField.key || !userDataField.label) return;
    result.push({
      type: userDataField.type,
      key: userDataField.key,
      label: userDataField.label
    });
  });
  return result;
}

function convertActionCategoriesToPublic(actionCategories) {
  if (!actionCategories) return [];
  var result = [];
  actionCategories.forEach(function (actionCategory) {
    if (!actionCategory || !actionCategory.type || !actionCategory.name) return;
    result.push({
      type: actionCategory.type,
      name: actionCategory.name,
      description: actionCategory.description,
      actions: convertActionCategoriesActionsToPublic(actionCategory.actions)
    });
  });
  return result;
}

function convertActionCategoriesActionsToPublic(actions) {
  if (!actions) return [];
  var result = [];
  actions.forEach(function (action) {
    var _a, _b;

    if (!action.label) return;
    result.push({
      // eslint-disable-next-line no-underscore-dangle
      id: action._id,
      type: action.type,
      label: action.label,
      target: action.target,
      camera: (_a = action.camera) !== null && _a !== void 0 ? _a : false,
      keyboard: (_b = action.keyboard) !== null && _b !== void 0 ? _b : false,
      destructive: action.destructive,
      icon: convertActionCategoriesActionIconToPublic(action.icon)
    });
  });
  return result;
}

function convertActionCategoriesActionIconToPublic(icon) {
  if (!icon) return undefined;
  if (!icon.android && !icon.ios && !(icon === null || icon === void 0 ? void 0 : icon.web)) return undefined;
  return {
    android: icon.android,
    ios: icon.ios,
    web: icon.web
  };
}

function convertCloudDynamicLinkToPublic(link) {
  return {
    target: link.target
  };
}

function isLatestStorageStructure() {
  return localStorage.getItem('re.notifica.migrated') === 'true';
}

function migrate() {
  logger.debug('Checking if there is legacy data that needs to be migrated.');

  if (hasLegacyStorage()) {
    var deviceStr = localStorage.getItem('notificareDevice');

    if (deviceStr) {
      logger.debug('Found legacy device stored.');

      try {
        var oldDevice = JSON.parse(deviceStr);
        var device = {
          id: oldDevice.deviceID,
          userId: oldDevice.userID,
          userName: oldDevice.userName,
          timeZoneOffset: oldDevice.timeZoneOffset,
          sdkVersion: oldDevice.sdkVersion,
          appVersion: oldDevice.appVersion,
          userAgent: oldDevice.userAgent,
          language: oldDevice.language,
          region: oldDevice.region,
          transport: oldDevice.transport,
          keys: oldDevice.keys,
          userData: {}
        };
        setStoredDevice(device);
      } catch (e) {
        logger.error('Failed to decode the legacy device.', e);
      }
    }

    var language = localStorage.getItem('notificarePreferredLanguage');

    if (language) {
      logger.debug('Found legacy language override stored.');
      localStorage.setItem('re.notifica.preferred_language', language);
    }

    var region = localStorage.getItem('notificarePreferredRegion');

    if (region) {
      logger.debug('Found legacy region override stored.');
      localStorage.setItem('re.notifica.preferred_region', region);
    } // eslint-disable-next-line no-restricted-syntax


    var _iterator2 = _createForOfIteratorHelper(components.values()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var component = _step2.value;
        logger.debug("Migrating '".concat(component.name, "' component."));
        component.migrate();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    localStorage.removeItem('notificareApplication');
    localStorage.removeItem('notificareDevice');
    localStorage.removeItem('notificareRegistration');
    localStorage.removeItem('notificareSession');
    localStorage.removeItem('notificareUnloadTimestamp');
    localStorage.removeItem('notificarePreferredLanguage');
    localStorage.removeItem('notificarePreferredRegion');
    logger.info('Legacy data found and migrated to the new storage format.');
  }

  localStorage.setItem('re.notifica.migrated', 'true');
}

function hasLegacyStorage() {
  return localStorage.getItem('notificareDevice') != null;
}

var SDK_VERSION = SDK_VERSION$1;

function setLogLevel(logLevel) {
  setLogLevel$1(logLevel);
}

function isConfigured() {
  return isConfigured$1();
}

function isReady() {
  return isReady$1();
}

function configure(options) {
  var _a, _b, _c, _d, _e;

  var state = getLaunchState();

  if (state > LaunchState.CONFIGURED) {
    logger.warning('Unable to reconfigure Notificare once launched.');
    return;
  }

  if (state === LaunchState.CONFIGURED) {
    logger.info('Reconfiguring Notificare with another set of application keys.');
  }

  logger.debug('Configuring notificare.');

  if (!(options === null || options === void 0 ? void 0 : options.applicationKey) || !(options === null || options === void 0 ? void 0 : options.applicationSecret)) {
    throw new Error('Unable to configure Notificare without a valid set of application keys.');
  }

  if (!isLatestStorageStructure()) {
    migrate();
  }

  var hosts = {
    cloudApi: (_b = (_a = options.hosts) === null || _a === void 0 ? void 0 : _a.cloudApi) !== null && _b !== void 0 ? _b : DEFAULT_CLOUD_API_HOST,
    restApi: (_d = (_c = options.hosts) === null || _c === void 0 ? void 0 : _c.restApi) !== null && _d !== void 0 ? _d : DEFAULT_REST_API_HOST
  };
  setOptions({
    hosts: hosts,
    applicationKey: options.applicationKey,
    applicationSecret: options.applicationSecret,
    applicationVersion: (_e = options.applicationVersion) !== null && _e !== void 0 ? _e : '1.0.0',
    ignoreTemporaryDevices: options.ignoreTemporaryDevices,
    ignoreUnsupportedWebPushDevices: options.ignoreUnsupportedWebPushDevices,
    applicationHost: "".concat(window.location.protocol, "//").concat(window.location.host),
    language: options.language,
    serviceWorker: options.serviceWorker,
    serviceWorkerScope: options.serviceWorkerScope,
    geolocation: options.geolocation
  }); // eslint-disable-next-line no-restricted-syntax

  var _iterator3 = _createForOfIteratorHelper(components.values()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var component = _step3.value;
      logger.debug("Configuring '".concat(component.name, "' component."));
      component.configure();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  setLaunchState(LaunchState.CONFIGURED);

  if (!isDefaultHosts(hosts)) {
    logger.info('Notificare configured with customized hosts.');
    logger.debug("Cloud API host: ".concat(hosts.cloudApi));
    logger.debug("REST API host: ".concat(hosts.restApi));
  }
}

function launch() {
  return _launch3.apply(this, arguments);
}

function _launch3() {
  _launch3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
    var response, _options2, options, isWebPushCapable, application, storedApplication, _iterator4, _step4, component, _iterator5, _step5, _component;

    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            if (!(getLaunchState() === LaunchState.LAUNCHING)) {
              _context34.next = 3;
              break;
            }

            logger.warning('Cannot launch again while Notificare is launching.');
            throw new Error('Cannot launch again while Notificare is launching.');

          case 3:
            if (!(getLaunchState() === LaunchState.LAUNCHED)) {
              _context34.next = 6;
              break;
            }

            logger.warning('Notificare has already launched. Skipping...');
            return _context34.abrupt("return");

          case 6:
            if (!(getLaunchState() < LaunchState.CONFIGURED)) {
              _context34.next = 16;
              break;
            }

            logger.debug('Fetching remote configuration.');
            _context34.next = 10;
            return request({
              url: '/notificare-services.json'
            });

          case 10:
            response = _context34.sent;
            _context34.next = 13;
            return response.json();

          case 13:
            _options2 = _context34.sent;
            configure(_options2);
            logger.info('Successfully configured Notificare with notificare-services.json.');

          case 16:
            options = getOptions();

            if (!(options == null)) {
              _context34.next = 19;
              break;
            }

            throw new Error('Unable to load options from /notificare-services.json.');

          case 19:
            if (!options.ignoreUnsupportedWebPushDevices) {
              _context34.next = 33;
              break;
            }

            isWebPushCapable = false;
            _context34.prev = 21;
            logger.debug('Checking for web push support.');
            _context34.next = 25;
            return hasWebPushSupport();

          case 25:
            isWebPushCapable = _context34.sent;
            _context34.next = 31;
            break;

          case 28:
            _context34.prev = 28;
            _context34.t0 = _context34["catch"](21);
            logger.warning('Failed to check for web push support.', _context34.t0);

          case 31:
            if (isWebPushCapable) {
              _context34.next = 33;
              break;
            }

            throw new Error('Unable to launch Notificare when the device is not capable of Web Push.');

          case 33:
            _context34.prev = 33;
            setLaunchState(LaunchState.LAUNCHING);
            _context34.next = 37;
            return fetchApplicationInternal({
              saveToLocalStorage: false
            });

          case 37:
            application = _context34.sent;
            storedApplication = getStoredApplication();

            if (!(storedApplication && storedApplication.id !== application.id)) {
              _context34.next = 60;
              break;
            }

            logger.warning('Incorrect application keys detected. Resetting Notificare to a clean state.'); // eslint-disable-next-line no-restricted-syntax

            _iterator4 = _createForOfIteratorHelper(components.values());
            _context34.prev = 42;

            _iterator4.s();

          case 44:
            if ((_step4 = _iterator4.n()).done) {
              _context34.next = 51;
              break;
            }

            component = _step4.value;
            logger.debug("Resetting '".concat(component.name, "' component.")); // eslint-disable-next-line no-await-in-loop

            _context34.next = 49;
            return component.clearStorage();

          case 49:
            _context34.next = 44;
            break;

          case 51:
            _context34.next = 56;
            break;

          case 53:
            _context34.prev = 53;
            _context34.t1 = _context34["catch"](42);

            _iterator4.e(_context34.t1);

          case 56:
            _context34.prev = 56;

            _iterator4.f();

            return _context34.finish(56);

          case 59:
            clearStorage();

          case 60:
            setStoredApplication(application); // eslint-disable-next-line no-restricted-syntax

            _iterator5 = _createForOfIteratorHelper(components.values());
            _context34.prev = 62;

            _iterator5.s();

          case 64:
            if ((_step5 = _iterator5.n()).done) {
              _context34.next = 71;
              break;
            }

            _component = _step5.value;
            logger.debug("Launching '".concat(_component.name, "' component.")); // eslint-disable-next-line no-await-in-loop

            _context34.next = 69;
            return _component.launch();

          case 69:
            _context34.next = 64;
            break;

          case 71:
            _context34.next = 76;
            break;

          case 73:
            _context34.prev = 73;
            _context34.t2 = _context34["catch"](62);

            _iterator5.e(_context34.t2);

          case 76:
            _context34.prev = 76;

            _iterator5.f();

            return _context34.finish(76);

          case 79:
            setLaunchState(LaunchState.LAUNCHED);
            printLaunchSummary(application);
            notifyOnReady(application);
            _context34.next = 89;
            break;

          case 84:
            _context34.prev = 84;
            _context34.t3 = _context34["catch"](33);
            logger.error('Failed to launch Notificare.', _context34.t3);
            setLaunchState(LaunchState.CONFIGURED);
            throw _context34.t3;

          case 89:
            // We don't want the launch() promise to be held for the postLaunch().
            postLaunch().catch(function (e) {
              return logger.error('Failed to execute the post-launch step.', e);
            });

          case 90:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, null, [[21, 28], [33, 84], [42, 53, 56, 59], [62, 73, 76, 79]]);
  }));
  return _launch3.apply(this, arguments);
}

function unlaunch() {
  return _unlaunch3.apply(this, arguments);
}

function _unlaunch3() {
  _unlaunch3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
    var _iterator6, _step6, component;

    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            if (isReady()) {
              _context35.next = 3;
              break;
            }

            logger.warning('Cannot un-launch Notificare before it has been launched.');
            throw new NotificareNotReadyError();

          case 3:
            logger.info('Un-launching Notificare.');
            _context35.prev = 4;
            // eslint-disable-next-line no-restricted-syntax
            _iterator6 = _createForOfIteratorHelper(Array.from(components.values()).reverse());
            _context35.prev = 6;

            _iterator6.s();

          case 8:
            if ((_step6 = _iterator6.n()).done) {
              _context35.next = 22;
              break;
            }

            component = _step6.value;
            logger.debug("Un-launching the '".concat(component.name, "' component."));
            _context35.prev = 11;
            _context35.next = 14;
            return component.unlaunch();

          case 14:
            _context35.next = 20;
            break;

          case 16:
            _context35.prev = 16;
            _context35.t0 = _context35["catch"](11);
            logger.debug("Failed to un-launch the '".concat(component.name, "' component."), _context35.t0); // noinspection ExceptionCaughtLocallyJS

            throw _context35.t0;

          case 20:
            _context35.next = 8;
            break;

          case 22:
            _context35.next = 27;
            break;

          case 24:
            _context35.prev = 24;
            _context35.t1 = _context35["catch"](6);

            _iterator6.e(_context35.t1);

          case 27:
            _context35.prev = 27;

            _iterator6.f();

            return _context35.finish(27);

          case 30:
            if (!getStoredDevice()) {
              _context35.next = 34;
              break;
            }

            logger.debug('Removing device.');
            _context35.next = 34;
            return deleteDevice();

          case 34:
            setStoredApplication(undefined);
            localStorage.removeItem('re.notifica.migrated');
            logger.info('Un-launched Notificare.');
            setLaunchState(LaunchState.CONFIGURED);
            notifyUnlaunched();
            _context35.next = 45;
            break;

          case 41:
            _context35.prev = 41;
            _context35.t2 = _context35["catch"](4);
            logger.error('Failed to un-launch Notificare.', _context35.t2);
            throw _context35.t2;

          case 45:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, null, [[4, 41], [6, 24, 27, 30], [11, 16]]);
  }));
  return _unlaunch3.apply(this, arguments);
}

function getApplication() {
  return getStoredApplication();
}

function fetchApplication() {
  return _fetchApplication.apply(this, arguments);
}

function _fetchApplication() {
  _fetchApplication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", fetchApplicationInternal({
              saveToLocalStorage: true
            }));

          case 1:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _fetchApplication.apply(this, arguments);
}

function fetchNotification(_x17) {
  return _fetchNotification.apply(this, arguments);
}

function _fetchNotification() {
  _fetchNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(id) {
    var _yield$fetchCloudNoti, notification;

    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            if (isConfigured()) {
              _context37.next = 2;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 2:
            _context37.next = 4;
            return fetchCloudNotification({
              environment: getCloudApiEnvironment(),
              id: id
            });

          case 4:
            _yield$fetchCloudNoti = _context37.sent;
            notification = _yield$fetchCloudNoti.notification;
            return _context37.abrupt("return", convertCloudNotificationToPublic(notification));

          case 7:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _fetchNotification.apply(this, arguments);
}

function fetchDynamicLink(_x18) {
  return _fetchDynamicLink.apply(this, arguments);
}

function _fetchDynamicLink() {
  _fetchDynamicLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(url) {
    var device, _yield$fetchCloudDyna, link;

    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            if (isConfigured()) {
              _context38.next = 2;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 2:
            device = getStoredDevice();
            _context38.next = 5;
            return fetchCloudDynamicLink({
              environment: getCloudApiEnvironment(),
              deviceId: device === null || device === void 0 ? void 0 : device.id,
              url: url
            });

          case 5:
            _yield$fetchCloudDyna = _context38.sent;
            link = _yield$fetchCloudDyna.link;
            return _context38.abrupt("return", convertCloudDynamicLinkToPublic(link));

          case 8:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _fetchDynamicLink.apply(this, arguments);
}

function createNotificationReply(_x19, _x20, _x21) {
  return _createNotificationReply.apply(this, arguments);
}

function _createNotificationReply() {
  _createNotificationReply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(notification, action, data) {
    var options, device, mediaUrl, _yield$uploadCloudNot, filename;

    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            if (isConfigured()) {
              _context39.next = 2;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 2:
            options = getOptions();

            if (options) {
              _context39.next = 5;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 5:
            device = getStoredDevice();

            if (device) {
              _context39.next = 8;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 8:
            if (!((data === null || data === void 0 ? void 0 : data.media) && (data === null || data === void 0 ? void 0 : data.mimeType))) {
              _context39.next = 14;
              break;
            }

            _context39.next = 11;
            return uploadCloudNotificationReplyMedia({
              environment: getCloudApiEnvironment(),
              media: data.media
            });

          case 11:
            _yield$uploadCloudNot = _context39.sent;
            filename = _yield$uploadCloudNot.filename;
            mediaUrl = "https://".concat(options.hosts.restApi, "/upload").concat(filename);

          case 14:
            _context39.next = 16;
            return createCloudNotificationReply({
              environment: getCloudApiEnvironment(),
              payload: {
                notification: notification.id,
                label: action.label,
                deviceID: device.id,
                userID: device.userId,
                data: {
                  target: action.target,
                  message: data === null || data === void 0 ? void 0 : data.message,
                  media: mediaUrl,
                  mimeType: data === null || data === void 0 ? void 0 : data.mimeType
                }
              }
            });

          case 16:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }));
  return _createNotificationReply.apply(this, arguments);
}

function callNotificationWebhook(_x22, _x23) {
  return _callNotificationWebhook.apply(this, arguments);
}

function _callNotificationWebhook() {
  _callNotificationWebhook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(notification, action) {
    var url, device, data;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            if (action.target) {
              _context40.next = 2;
              break;
            }

            throw new Error('Unable to execute webhook without a target for the action.');

          case 2:
            url = new URL(action.target);
            device = getStoredDevice();
            data = {
              target: url.origin,
              label: action.label,
              notificationID: notification.id,
              deviceID: device === null || device === void 0 ? void 0 : device.id,
              userID: device === null || device === void 0 ? void 0 : device.userId
            }; // Populate the data with the target's query parameters.

            url.searchParams.forEach(function (key) {
              var value = url.searchParams.get(key);
              if (value !== null) data[key] = value;
            });
            _context40.next = 8;
            return callCloudNotificationWebhook({
              environment: getCloudApiEnvironment(),
              payload: data
            });

          case 8:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }));
  return _callNotificationWebhook.apply(this, arguments);
}

function printLaunchSummary(application) {
  if (logger.getLogLevel() >= LogLevel.INFO) {
    logger.info('Notificare is ready.');
    return;
  }

  var enabledServices = Object.entries(application.services).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        enabled = _ref4[1];

    return enabled;
  }).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
        service = _ref6[0];

    return service;
  });

  var enabledComponents = _toConsumableArray(components.keys()).sort();

  logger.debug('/==============================================================================/');
  logger.debug('Notificare SDK is ready to use for application');
  logger.debug("App name: ".concat(application.name));
  logger.debug("App ID: ".concat(application.id));
  logger.debug("App services: ".concat(enabledServices.join(', ')));
  logger.debug('/==============================================================================/');
  logger.debug("SDK version: ".concat(SDK_VERSION));
  logger.debug("SDK modules: ".concat(enabledComponents.join(', ')));
  logger.debug('/==============================================================================/');
}

function postLaunch() {
  return _postLaunch3.apply(this, arguments);
}

function _postLaunch3() {
  _postLaunch3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
    var _iterator7, _step7, component;

    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            // eslint-disable-next-line no-restricted-syntax
            _iterator7 = _createForOfIteratorHelper(components.values());
            _context41.prev = 1;

            _iterator7.s();

          case 3:
            if ((_step7 = _iterator7.n()).done) {
              _context41.next = 16;
              break;
            }

            component = _step7.value;
            _context41.prev = 5;
            logger.debug("Post-launch '".concat(component.name, "' component.")); // eslint-disable-next-line no-await-in-loop

            _context41.next = 9;
            return component.postLaunch();

          case 9:
            _context41.next = 14;
            break;

          case 11:
            _context41.prev = 11;
            _context41.t0 = _context41["catch"](5);
            logger.error("Failed to post-launch the '".concat(component.name, "' component."), _context41.t0);

          case 14:
            _context41.next = 3;
            break;

          case 16:
            _context41.next = 21;
            break;

          case 18:
            _context41.prev = 18;
            _context41.t1 = _context41["catch"](1);

            _iterator7.e(_context41.t1);

          case 21:
            _context41.prev = 21;

            _iterator7.f();

            return _context41.finish(21);

          case 24:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41, null, [[1, 18, 21, 24], [5, 11]]);
  }));
  return _postLaunch3.apply(this, arguments);
}

function fetchApplicationInternal(_x24) {
  return _fetchApplicationInternal.apply(this, arguments);
}

function _fetchApplicationInternal() {
  _fetchApplicationInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(_ref7) {
    var saveToLocalStorage, options, _yield$fetchCloudAppl, cloudApplication, application;

    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            saveToLocalStorage = _ref7.saveToLocalStorage;

            if (isConfigured()) {
              _context42.next = 3;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 3:
            options = getOptions();

            if (options) {
              _context42.next = 6;
              break;
            }

            throw new NotificareNotConfiguredError();

          case 6:
            _context42.next = 8;
            return fetchCloudApplication({
              environment: getCloudApiEnvironment(),
              language: options.language
            });

          case 8:
            _yield$fetchCloudAppl = _context42.sent;
            cloudApplication = _yield$fetchCloudAppl.application;
            application = convertCloudApplicationToPublic(cloudApplication);

            if (saveToLocalStorage) {
              setStoredApplication(application);
            }

            return _context42.abrupt("return", application);

          case 13:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _fetchApplicationInternal.apply(this, arguments);
}

function getCurrentDevice() {
  var device = getStoredDevice();
  if (!device) return undefined;
  return asPublicDevice(device);
}

function updateUser(_x25) {
  return _updateUser.apply(this, arguments);
}
/**
 * @deprecated Use updateUser() instead.
 *
 * @param options
 */


function _updateUser() {
  _updateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref8) {
    var userId, userName, device;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            userId = _ref8.userId, userName = _ref8.userName;
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context43.next = 5;
              break;
            }

            throw new NotificareNotReadyError();

          case 5:
            _context43.next = 7;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                userID: userId !== null && userId !== void 0 ? userId : null,
                userName: userName !== null && userName !== void 0 ? userName : null
              }
            });

          case 7:
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              userId: userId !== null && userId !== void 0 ? userId : undefined,
              userName: userName !== null && userName !== void 0 ? userName : undefined
            }));

          case 8:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
  return _updateUser.apply(this, arguments);
}

function registerDevice(_x26) {
  return _registerDevice.apply(this, arguments);
}

function _registerDevice() {
  _registerDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(options) {
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.next = 2;
            return updateUser(options);

          case 2:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _registerDevice.apply(this, arguments);
}

function getPreferredLanguage() {
  var preferredLanguage = localStorage.getItem('re.notifica.preferred_language');
  if (!preferredLanguage) return undefined;
  var preferredRegion = localStorage.getItem('re.notifica.preferred_region');
  if (!preferredRegion) return undefined;
  return "".concat(preferredLanguage, "-").concat(preferredRegion);
}

function updatePreferredLanguage(_x27) {
  return _updatePreferredLanguage.apply(this, arguments);
}

function _updatePreferredLanguage() {
  _updatePreferredLanguage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(language) {
    var device, parts;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context45.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            if (!language) {
              _context45.next = 12;
              break;
            }

            parts = language.split('-');

            if (!(parts.length !== 2)) {
              _context45.next = 8;
              break;
            }

            throw new Error("".concat(language, " is not a valid language. Use a ISO 639-1 language code and a ISO 3166-2 region code (e.g. en-US)."));

          case 8:
            localStorage.setItem('re.notifica.preferred_language', parts[0]);
            localStorage.setItem('re.notifica.preferred_region', parts[1]);
            _context45.next = 14;
            break;

          case 12:
            localStorage.removeItem('re.notifica.preferred_language');
            localStorage.removeItem('re.notifica.preferred_region');

          case 14:
            _context45.next = 16;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                language: getDeviceLanguage(),
                region: getDeviceRegion()
              }
            });

          case 16:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _updatePreferredLanguage.apply(this, arguments);
}

function fetchTags() {
  return _fetchTags.apply(this, arguments);
}

function _fetchTags() {
  _fetchTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
    var device, _yield$fetchCloudDevi, tags;

    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context46.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context46.next = 6;
            return fetchCloudDeviceTags({
              environment: getCloudApiEnvironment(),
              deviceId: device.id
            });

          case 6:
            _yield$fetchCloudDevi = _context46.sent;
            tags = _yield$fetchCloudDevi.tags;
            return _context46.abrupt("return", tags !== null && tags !== void 0 ? tags : []);

          case 9:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _fetchTags.apply(this, arguments);
}

function addTag(_x28) {
  return _addTag.apply(this, arguments);
}

function _addTag() {
  _addTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(tag) {
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.next = 2;
            return addTags([tag]);

          case 2:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }));
  return _addTag.apply(this, arguments);
}

function addTags(_x29) {
  return _addTags.apply(this, arguments);
}

function _addTags() {
  _addTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(tags) {
    var device;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context48.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context48.next = 6;
            return addCloudDeviceTags({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              tags: tags
            });

          case 6:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
  return _addTags.apply(this, arguments);
}

function removeTag(_x30) {
  return _removeTag.apply(this, arguments);
}

function _removeTag() {
  _removeTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(tag) {
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.next = 2;
            return removeTags([tag]);

          case 2:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));
  return _removeTag.apply(this, arguments);
}

function removeTags(_x31) {
  return _removeTags.apply(this, arguments);
}

function _removeTags() {
  _removeTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(tags) {
    var device;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context50.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context50.next = 6;
            return removeCloudDeviceTags({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              tags: tags
            });

          case 6:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }));
  return _removeTags.apply(this, arguments);
}

function clearTags() {
  return _clearTags.apply(this, arguments);
}

function _clearTags() {
  _clearTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
    var device;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context51.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context51.next = 6;
            return clearCloudDeviceTags({
              environment: getCloudApiEnvironment(),
              deviceId: device.id
            });

          case 6:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  }));
  return _clearTags.apply(this, arguments);
}

function fetchDoNotDisturb() {
  return _fetchDoNotDisturb.apply(this, arguments);
}

function _fetchDoNotDisturb() {
  _fetchDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
    var device, _yield$fetchCloudDevi2, dnd;

    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context52.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context52.next = 6;
            return fetchCloudDeviceDoNotDisturb({
              environment: getCloudApiEnvironment(),
              deviceId: device.id
            });

          case 6:
            _yield$fetchCloudDevi2 = _context52.sent;
            dnd = _yield$fetchCloudDevi2.dnd;
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              dnd: dnd !== null && dnd !== void 0 ? dnd : undefined
            }));
            return _context52.abrupt("return", dnd !== null && dnd !== void 0 ? dnd : undefined);

          case 10:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }));
  return _fetchDoNotDisturb.apply(this, arguments);
}

function updateDoNotDisturb(_x32) {
  return _updateDoNotDisturb.apply(this, arguments);
}

function _updateDoNotDisturb() {
  _updateDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(dnd) {
    var device;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context53.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context53.next = 6;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                dnd: dnd
              }
            });

          case 6:
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              dnd: dnd
            }));

          case 7:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }));
  return _updateDoNotDisturb.apply(this, arguments);
}

function clearDoNotDisturb() {
  return _clearDoNotDisturb.apply(this, arguments);
}

function _clearDoNotDisturb() {
  _clearDoNotDisturb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    var device;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context54.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context54.next = 6;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                dnd: null
              }
            });

          case 6:
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              dnd: undefined
            }));

          case 7:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));
  return _clearDoNotDisturb.apply(this, arguments);
}

function fetchUserData() {
  return _fetchUserData.apply(this, arguments);
}

function _fetchUserData() {
  _fetchUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
    var device, _yield$fetchCloudDevi3, userData;

    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context55.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context55.next = 6;
            return fetchCloudDeviceUserData({
              environment: getCloudApiEnvironment(),
              deviceId: device.id
            });

          case 6:
            _yield$fetchCloudDevi3 = _context55.sent;
            userData = _yield$fetchCloudDevi3.userData;
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              userData: userData !== null && userData !== void 0 ? userData : {}
            }));
            return _context55.abrupt("return", userData !== null && userData !== void 0 ? userData : {});

          case 10:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55);
  }));
  return _fetchUserData.apply(this, arguments);
}

function updateUserData(_x33) {
  return _updateUserData.apply(this, arguments);
}

function _updateUserData() {
  _updateUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(userData) {
    var device;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            checkPrerequisites();
            device = getStoredDevice();

            if (device) {
              _context56.next = 4;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 4:
            _context56.next = 6;
            return updateCloudDevice({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              payload: {
                userData: userData
              }
            });

          case 6:
            // Update current device properties.
            setStoredDevice(Object.assign(Object.assign({}, device), {
              userData: userData
            }));

          case 7:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));
  return _updateUserData.apply(this, arguments);
}

registerComponents();
export { Component, NotificareApplicationUnavailableError, NotificareDeviceUnavailableError, NotificareNotConfiguredError, NotificareNotReadyError, NotificareServiceUnavailableError, SDK_VERSION, addTag, addTags, broadcastComponentEvent, callNotificationWebhook, clearDoNotDisturb, clearTags, configure, convertCloudNotificationToPublic, createNotificationReply, executeComponentCommand, fetchApplication, fetchDoNotDisturb, fetchDynamicLink, fetchNotification, fetchTags, fetchUserData, getApplication, getCloudApiEnvironment, getCurrentDevice, getOptions, getPreferredLanguage, isConfigured, isReady, launch, loadStylesheet, logCustom, logInternal, logNotificationOpen, onDeviceRegistered, onReady, onUnlaunched, registerComponent, registerDevice, removeTag, removeTags, setLogLevel, unlaunch, updateDoNotDisturb, updatePreferredLanguage, updateUser, updateUserData };